<template>
    <v-alert
        v-if="showAlert"
        :type="alertType"
        class="mx-auto text-center"
        style="position: fixed; top: 20px; left: 0; right: 0; z-index: 9999; max-width: 600px;"
        elevation="2"
        prominent
    >
        {{ alertMessage }}
    </v-alert>
    <v-container fluid>
        <v-card class="pa-4">
            <v-row>
                <v-col class="headline mb-4">
                    <h2>Historial de: {{ decodedDescription }}</h2>
                </v-col>
                <v-col cols="12" sm="2" style="text-align: right">
                    <v-btn style="margin-left: 10px"  @click="$router.back()">Volver</v-btn>
                </v-col>
            </v-row>
            <v-data-table
                :items="history"
                :headers="headers"
                class="elevation-1"
                item-value="id"
                no-data-text="No hi ha registres d’historial"
            ></v-data-table>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'

const route = useRoute()

import { useAlert } from '@/composables/useAlert'

const {
    alertMessage,
    alertType,
    showAlert,
    showAlertMessage
} = useAlert()

const decodedDescription = computed(() => decodeURIComponent(route.params.description))
const history = ref([])

const headers = [
    { title: 'Fecha', value: 'created_at' },
    { title: 'Usuario', value: 'user' },
    { title: 'Descripción', value: 'description' },
    { title: 'Cantidad total', value: 'quantity_total' },
    { title: 'Cantidad entrada', value: 'quantity_in' },
    { title: 'Cantidad salida', value: 'quantity_out' },
    { title: 'Estado', value: 'status' },
    { title: 'Notas', value: 'notes' }
]

onMounted(async () => {
    try {
        const { data } = await axios.get(`/api/admin/stocks/history/${encodeURIComponent(decodedDescription.value)}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        history.value = data
    } catch (e) {
        showAlertMessage('Error carregant l’historial', 'error')
        console.error('Error carregant l’historial:', e)
    }
})
</script>
